import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

import { getMenuCss } from '../helper';

export const Wrapper = styled.ul`
  display: flex;
  margin-left: auto;
`;

export const MenuItem = styled.li<{ gnbId: string }>`
  position: relative;
  padding-left: 20px;
  margin: 0 16px;
  color: ${({ theme }) => theme.colors.gray800};
  ${getFontStyle('bold150_B3')};

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    display: block;
    width: 16px;
    height: 16px;
    background-size: 16px auto;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${({ gnbId }) => getMenuCss(gnbId)};
`;
